import { GridColDef } from "@mui/x-data-grid";
import { useGetLocale } from "@refinedev/core";
import { useMemo } from "react";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { PaginatedList } from "../../../../../components/form/PaginatedList/PaginatedList";
import { ExceptionAddButton } from "./components/ExceptionAddButton";
import { Alert } from "@mui/material";

const getColumns = (
  translate: (_key: string) => string,
  locales: Intl.LocalesArgument,
): GridColDef[] => [
  {
    field: "competitorSellerId",
    headerName: translate("fields.competitorSellerId"),
    flex: 2,
  },
  {
    field: "created",
    headerName: translate("fields.created"),
    flex: 1,
    valueFormatter: (value: string) => {
      const date = new Date(value).toLocaleDateString(locales);
      const time = new Date(value).toLocaleTimeString(locales);

      return `${date} ${time}`;
    },
  },
];

export const CompetitionExceptionList = () => {
  const locale = useGetLocale();
  const currentLocale = locale();

  const { translate } = useTranslation(
    "pages.stores.competitionSettings.competitionExceptionList",
  );

  const columns = useMemo(
    () => getColumns(translate, currentLocale),
    [currentLocale],
  );

  return (
    <>
      <Alert severity="info">{translate("description")}</Alert>
      <PaginatedList
        addButton={<ExceptionAddButton />}
        getUrl={(countryId) => `store/${countryId}/competitors`}
        columns={columns}
        searchable={false}
        downloadable={false}
        disableMultipleRowSelection
      />
    </>
  );
};
